import type { TransactionCurrency } from '@contracts/payment/Currency';
import type {
  AddressField,
  AddressLine2Field,
  CityField,
  CountryCodeField,
  CreditCardNumberField,
  CvvField,
  EmailField,
  ExpirationField,
  FirstNameField,
  LastNameField,
  NameOnCardField,
  SaveCardOnFileField,
  StateField,
  ZipField,
} from '@src/clients/financialSettings/fields/CreditCardFields';
import type { CurrencyField } from '@src/clients/financialSettings/fields/CurrencyFields';
import type { MakePaymentAmountField } from '@src/orders/fields/MakePaymentFields';
import type { AmountField } from '@src/orders/fields/PreauthorizePaymentFields';
import * as yup from 'yup';

export class CreditCardField {
  public static fieldName = 'creditCard' as const;
  public static validator = yup.string().required();
}

export type CreditCardRelatedFields = {
  [AmountField.fieldName]: number;
  [MakePaymentAmountField.fieldName]: number;
  [CurrencyField.fieldName]: keyof typeof TransactionCurrency;
  [CreditCardField.fieldName]: string;
  [CvvField.fieldName]: string;
  [CreditCardNumberField.fieldName]: string;
  [ExpirationField.fieldName]: string;
  [NameOnCardField.fieldName]: string;
  [EmailField.fieldName]: string;
  [FirstNameField.fieldName]: string;
  [LastNameField.fieldName]: string;
  [AddressField.fieldName]: string;
  [AddressLine2Field.fieldName]?: string;
  [ZipField.fieldName]: string;
  [CityField.fieldName]: string;
  [CountryCodeField.fieldName]: string;
  [StateField.fieldName]: string;
  [SaveCardOnFileField.fieldName]: boolean;
};
